import parsePhoneNumber from 'libphonenumber-js';

import {
  getAttributeInfo,
  getMedicalInfoWithIds,
  medicalFormValues,
} from '../MedicalInformation/utils';

export const requiredContactFormValues = {
  state                  : '',
  city                   : '',
  postal_code            : '',
  hasMigratedContactInfo : '',
};
export const initialContactFormValues = {
  ...requiredContactFormValues,
  home_phone : '',
  phone      : '',
  address    : '',
};

export const getContactInfoWithIds = (attributes, contactFormValues) => {
  const contactWithIdsRecords = {};
  getAttributeInfo(attributes, contactFormValues).forEach((personAttribute) => {
    const attributes = personAttribute.data.attributes;
    contactWithIdsRecords[attributes.name] = {
      id    : personAttribute.data.id,
      value : attributes.value,
    };
  });
  return contactWithIdsRecords;
};

export const contactInfoPayload = ({ attributes, data, person }) => {
  let ids = getContactInfoWithIds(person, initialContactFormValues);
  ids = { ...ids, ...getMedicalInfoWithIds(person, medicalFormValues) };
  const personAttributes = [
    ...(data.date_of_birth
      ? [
        {
          type       : 'person_attribute',
          ...(ids.date_of_birth ? { id: ids.date_of_birth.id } : {}),
          attributes : {
            attribute : 'date_of_birth',
            value     : data.date_of_birth,
          },
        },
      ]
      : []),
    {
      type       : 'person_attribute',
      ...(ids.home_phone ? { id: ids.home_phone.id } : {}),
      attributes : {
        attribute : 'home_phone',
        value     : data.home_phone,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.phone ? { id: ids.phone.id } : {}),
      attributes : {
        attribute : 'phone',
        value     : data.phone,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.gender ? { id: ids.gender.id } : {}),
      attributes : {
        attribute : 'gender',
        value     : data.gender,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.state ? { id: ids.state.id } : {}),
      attributes : {
        attribute : 'state',
        value     : data.state,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.city ? { id: ids.city.id } : {}),
      attributes : {
        attribute : 'city',
        value     : data.city,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.postal_code ? { id: ids.postal_code.id } : {}),
      attributes : {
        attribute : 'postal_code',
        value     : data.postal_code,
      },
    },
    {
      type       : 'person_attribute',
      ...(ids.address ? { id: ids.address.id } : {}),
      attributes : {
        attribute : 'address',
        value     : data.address,
      },
    },
    {
      type : 'person_attribute',
      ...(ids.hasMigratedContactInfo
        ? { id: ids.hasMigratedContactInfo.id }
        : {}),
      attributes : {
        attribute : 'hasMigratedContactInfo',
        value     : 'yes',
      },
    },
  ];
  const filteredPersonAttributes = personAttributes.filter((personAttribute) =>
    Boolean(personAttribute.attributes.value)
  );

  return {
    attributes,
    relationships : {
      person_attribute : filteredPersonAttributes,
    },
  };
};

export const getPersonContactRecords = (attributes, onlyRequired = false) => {
  const contactFormValues = onlyRequired
    ? requiredContactFormValues
    : initialContactFormValues;
  const contactRecords = {};
  getAttributeInfo(attributes, contactFormValues).forEach((personAttribute) => {
    if (personAttribute.value.toLowerCase() !== 'unknown') {
      contactRecords[personAttribute.attribute] = personAttribute.value;
    }
  });
  return contactRecords;
};

export const formatAttributeName = (payload = [], attributesArray = []) => {
  return payload.map((details) => {
    const findOldAttribute = attributesArray.find(
      (attribute) => attribute.old === details.data.attributes.attribute
    );
    if (findOldAttribute) {
      details.data.attributes.attribute = findOldAttribute.new;
    }

    return details;
  });
};

export const parseContactNumber = (number, format) => {
  if (!number) {
    return null;
  }
  const phoneNumber = parsePhoneNumber(number, 'US');
  return phoneNumber[format];
};

export const formatPhoneNumbers = (payload = []) => {
  return payload.map((details) => {
    if (
      ['home_phone', 'phone'].includes(details.data.attributes.attribute) &&
      Boolean(details.data.attributes.value)
    ) {
      details.data.attributes.value = parseContactNumber(
        details.data.attributes.value,
        'number'
      );
    }
    return details;
  });
};

export const formatNationalPhoneNumber = (number) => {
  return parseContactNumber(number, 'nationalNumber');
};

export const hasNonEmptyProperty = (obj) =>
  Object.values(obj ?? {}).some((value) => Boolean(value));

export const hasEmptyProperties = (obj) =>
  Object.values(obj ?? {}).every((value) => !value);
